module.exports = __webpack_public_path__ + "img/1001.5b50cebb.jpg";